module.exports = __webpack_public_path__ + "img/coin-004.cf80773e.svg";